import React from "react"
import { getApiEnv, setApiEnv } from "../../helpers/apiEnv"

/**
 * Selector Producción / QA para la fuente de datos de analítica.
 * Al cambiar, recarga la página para que todas las vistas vuelvan a
 * consultar contra el entorno elegido. Se usa dentro del topbar
 * (visible solo para administradores — ver gating en el Header).
 */
const ApiEnvSwitcher = () => {
  const env = getApiEnv()
  const esQa = env === "qa"

  const cambiar = (nuevo) => {
    if (nuevo === env) return
    setApiEnv(nuevo)
    window.location.reload()
  }

  return (
    <div
      title="Fuente de datos de analítica (Producción / QA)"
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 2,
        background: esQa ? "#fee2e2" : "#f1f5f9",
        border: `1px solid ${esQa ? "#fca5a5" : "#e2e8f0"}`,
        borderRadius: 8,
        padding: 2,
        marginRight: 8,
      }}
    >
      {["prod", "qa"].map((k) => {
        const activo = env === k
        const qa = k === "qa"
        return (
          <button
            key={k}
            type="button"
            onClick={() => cambiar(k)}
            style={{
              border: "none",
              borderRadius: 6,
              padding: "4px 10px",
              fontSize: "0.72rem",
              fontWeight: 800,
              cursor: "pointer",
              textTransform: "uppercase",
              letterSpacing: 0.4,
              background: activo ? (qa ? "#dc2626" : "#fff") : "transparent",
              color: activo ? (qa ? "#fff" : "#0f172a") : "#64748b",
              boxShadow: activo && !qa ? "0 1px 2px rgba(0,0,0,0.15)" : "none",
            }}
          >
            {qa ? "QA" : "PROD"}
          </button>
        )
      })}
    </div>
  )
}

export default ApiEnvSwitcher
